/**
 * @ngdoc service
 * @name utils
 *
 * @description utils fonctions custom service.
 */
module.factory('utils', function ($http, $document, $timeout, $interval) {
    return {
        calendarTrad: function(lang){
            $timeout(function(){
                // Langue de références
                $calendar_langs = {
                    "Italien": "it",
                    "Anglais": "en",
                    "Français": "fr"
                };
                // Mois de références
                $calendar_months_models = {
                    "fr": ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
                    "en": ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"],
                    "it": ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
                };
                // Jours de référence
                $calendar_days_model = {
                    "fr": ["lun.", "mar.", "mer.", "jeu.", "ven.", "sam.", "dim."],
                    "en": ["mon.", "tue.", "wed.", "thu.", "fri.", "sat.", "sun."],
                    "it": ["lun.", "mar.", "mer.", "gio.", "ven.", "sab.", "dom."]
                };
                $calendar_month_selected = document.querySelectorAll('._720kb-datepicker-calendar-header-middle._720kb-datepicker-calendar-month'); // Mois affiché dans le widget
                $calendar_days = document.querySelectorAll('._720kb-datepicker-calendar-days-header'); // Listes des jours dans le widget
                $calendar_button_change_months = document.querySelectorAll('._720kb-datepicker-calendar-month-button'); // Boutons de changement de mois dans le widget
                ; // Langue au démarrage

                // Attribution au click des boutons du widget la traduction du mois
                if($calendar_button_change_months.length > 0){
                    $calendar_button_change_months.forEach(function(elem){
                        elem.addEventListener("click", function(){
                            goTradMonth()
                        })
                    });
                } else {
                    console.log("Les boutons de changement de mois n'ont pas été trouvés")
                }

                // Fonction de recherche de correspondance entre le jour affiché et le mois/jour de référénce
                // Renvoi un Integer -> index dans le tableau
                function findtrad(value, tabModels){
                    return new Promise(function(resolve){
                        $index = null;
                        Object.entries(tabModels).forEach(function(elem){
                            elem[1].forEach(function(e,i){
                                if(e.trim() === value.trim()){
                                    $index = i;
                                }
                            });
                        })
                        resolve($index);
                    });
                }

                function getLanguage(lang){
                    $a = lang == "Sélectionner une langue" ? "Français" : lang
                    return $calendar_langs[$a];
                }

                function goTradMonth(){
                    Array.from($calendar_month_selected).forEach(function(element){
                        $currentLanguage = document.querySelector(".VIpgJd-ZVi9od-xl07Ob-lTBxed span").innerHTML
                        $language = getLanguage($currentLanguage);
                        findtrad(element.firstChild.textContent, $calendar_months_models)
                            .then(function(response){
                                element.firstChild.textContent = $calendar_months_models[$language][response]
                            })
                            .catch(function(error){
                                console.log("erreur goTradMonth", error)
                            });
                    });
                }

                function goTradDays(){
                    $calendar_days.forEach(function(elem){
                        elem.querySelectorAll("div").forEach(function(e){
                            $currentLanguage = document.querySelector(".VIpgJd-ZVi9od-xl07Ob-lTBxed span").innerHTML
                            $language = getLanguage($currentLanguage);
                            findtrad(e.innerHTML, $calendar_days_model)
                                .then(function(response){
                                    e.innerHTML = $calendar_days_model[$language][response];
                                })
                                .catch(function(error){
                                    console.log("erreur goTradDays", error)
                                })
                        })
                    })
                }

                // Lancement des traductions au lancement de la page
                if($calendar_month_selected.length > 0){
                    goTradMonth()
                } else {
                    console.log("Les mois n'ont pas été trouvés")
                }

                if($calendar_days.length > 0){
                    goTradDays()
                } else {
                    console.log("Les jours n'ont pas été trouvés")
                }


                // Déclenchement de la traduction Jour / Mois en fonction de la langue modifiée
                document.querySelector(".VIpgJd-ZVi9od-xl07Ob-lTBxed span").addEventListener("DOMSubtreeModified", function(){
                    goTradMonth()
                    goTradDays()
                });
            }, 500)
        }
    }
});
